import api from '@/api';
import _ from 'lodash';
import { DateTime } from 'luxon';

export default {
    state: {
        elecciones: [],
        eleccion: {},
    },
    getters: {
        elecciones: state => state.elecciones,
        eleccion: state => state.eleccion,
    },
    mutations: {
        SET_ELECCIONES(state, elecciones) {
            state.elecciones = elecciones;
        },
        SET_ELECCION(state, eleccion) {
            state.eleccion = eleccion;
        },
        SET_ELECTION_FILE(state, { election_id, file, url }) {
            console.log(state.eleccion);
            console.log({ election_id, file, url });

            if (state.eleccion.id === election_id) {
                _.set(state, `eleccion.${file}`, url);
                console.log('file set', file);
            }
        },
        DELETE_ELECCIONES(state, election_id) {
            state.elecciones = state.elecciones.filter(
                election => election.id !== election_id
            );
        },
        UPDATE_ELECCTION(state, data) {
            const election = state.elecciones.find(
                election => parseInt(election.id) === parseInt(data.election_id)
            );

            if (election) {
                election.cron_status = data.cron_status
                    ? data.cron_status
                    : 'processing';

                if (data.type) {
                    election.election_status = `${data.type}: ${data.currentRow}/${data.total}`;
                }

                if (data.offset_ballots) {
                    election.election_status = `Blockchain Boletas: ${data.offset_ballots}/${data.total}`;
                }

                if (data.offset) {
                    election.election_status = `Planillas: ${data.offset}/${data.total_candidates}`;
                }

                if (data.offset_officials) {
                    election.bc_status = `Password officials: ${data.offset_officials}/${data.total}`;
                }

                if (data.offset_sub) {
                    election.bc_status = `Password sub: ${data.offset_sub}/${data.total}`;
                }

                if (data.change_status) {
                    election.election_status = data.change_status;
                }
            }
        },
        UPDATE_ELECTION(state, election) {
            let electionSelected = state.elecciones.find(
                e => e.id === election.id
            );
            if (electionSelected) {
                electionSelected.cron_error = election.cron_error;
                electionSelected.cron_status = election.cron_status;
            }
        },
    },
    actions: {
        getElecciones({ commit }) {
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await api.get('/get-elections');

                    if (response.data && response.data.elecciones) {
                        const elecciones = response.data.elecciones.map(
                            eleccion => {
                                eleccion.start = eleccion.start_date;
                                eleccion.end = eleccion.end_date;

                                eleccion.created_at = DateTime.fromISO(
                                    eleccion.created_at
                                ).toLocaleString(DateTime.DATETIME_MED);

                                eleccion.start_date = DateTime.fromISO(
                                    eleccion.start_date
                                ).toLocaleString(DateTime.DATETIME_MED);

                                eleccion.end_date = DateTime.fromISO(
                                    eleccion.end_date
                                ).toLocaleString(DateTime.DATETIME_MED);

                                return eleccion;
                            }
                        );
                        commit('SET_ELECCIONES', elecciones);
                    } else {
                        console.error('Elecciones error');
                        console.error(
                            _.get(response, 'data.reason') || "Can't get data"
                        );
                        commit('SET_ELECCIONES', []);
                        reject(
                            _.get(response, 'data.reason') || "Can't get data"
                        );
                    }
                    resolve();
                } catch (error) {
                    reject(error);
                }
            });
        },
        getEleccion({ commit }, eleccion_id) {
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await api.get(`/elections/${eleccion_id}`);

                    if (response.data && response.data.eleccion) {
                        const eleccion = response.data.eleccion;

                        eleccion.created_at = DateTime.fromISO(
                            eleccion.created_at
                        ).toLocaleString(DateTime.DATETIME_MED);

                        eleccion.start_date = DateTime.fromISO(
                            eleccion.start_date
                        ).toLocaleString(DateTime.DATETIME_MED);

                        eleccion.end_date = DateTime.fromISO(
                            eleccion.end_date
                        ).toLocaleString(DateTime.DATETIME_MED);

                        commit('SET_ELECCION', eleccion);
                    } else {
                        console.error('Elecciones error');
                        console.error(
                            _.get(response, 'data.reason') || "Can't get data"
                        );
                        commit('SET_ELECCION', {});
                        reject(
                            _.get(response, 'data.reason') || "Can't get data"
                        );
                    }
                    resolve();
                } catch (error) {
                    reject(error);
                }
            });
        },
        startElection(
            { commit, dispatch },
            {
                start_date,
                end_date,
                type_id,
                election_label,
                ws_production,
                emails_enabled,
            }
        ) {
            return new Promise(async function(resolve, reject) {
                try {
                    const response = await api.post('/start-election', {
                        start_date,
                        end_date,
                        type_id,
                        election_label,
                        ws_production,
                        emails_enabled,
                    });

                    if (response.status !== 200 && response.data) {
                        return reject(response.data.reason);
                    }
                    resolve(true);
                } catch (error) {
                    reject(error);
                }
            });
        },
        editElection(
            { commit, dispatch },
            { start_date, end_date, description, election_id }
        ) {
            return new Promise(async function(resolve, reject) {
                try {
                    const response = await api.patch(
                        `/elections/${election_id}`,
                        {
                            start_date,
                            end_date,
                            description,
                        }
                    );

                    if (response.status !== 200 && response.data) {
                        return reject(response.data.reason);
                    }
                    resolve(true);
                } catch (error) {
                    reject(error);
                }
            });
        },
        getState({ commit }, election_id) {
            return new Promise(async function(resolve, reject) {
                const response = await api.get(`/get-stage/${election_id}`);

                if (response.status !== 200 && response.data) {
                    return reject(response.data.reason);
                }
                resolve(response.data);
            });
        },
        startVoting({ commit }, election_id) {
            return new Promise(async function(resolve, reject) {
                const response = await api.post('/start-voting', {
                    id: election_id,
                });
                if (response.status !== 200 && response.data) {
                    return reject(response.data.reason);
                }
                resolve(response.data);
            });
        },
        deleteElecciones() {
            return new Promise(function(resolve, reject) {
                api.delete('/elections')
                    .then(response => {
                        resolve();
                    })
                    .catch(reject);
            });
        },
        deleteEleccion: ({ commit }, election_id) => {
            return new Promise(async function(resolve, reject) {
                try {
                    const response = await api.delete(
                        `/elections/${election_id}`
                    );
                    if (response.status !== 200 && response.data) {
                        return reject(response.data.reason);
                    }

                    commit('DELETE_ELECCIONES', election_id);
                    resolve();
                } catch (error) {
                    reject(error);
                }
            });
        },
        getRecords: ({ commit }) => {
            return new Promise(async function(resolve, reject) {
                try {
                    const response = await api.get('/votes-record');

                    if (response.status !== 200 && response.data) {
                        return reject(response.data.reason);
                    }
                    resolve(response.data);
                } catch (error) {
                    reject(error);
                }
            });
        },
        retryElection: ({ commit }, election_id) => {
            return new Promise(async function(resolve, reject) {
                try {
                    const response = await api.put(`/elections/${election_id}`);
                    if (response.status !== 200 && response.data) {
                        return reject(response.data.reason);
                    }
                    commit('UPDATE_ELECTION', response.data.election);
                    resolve();
                } catch (error) {
                    reject(error);
                }
            });
        },
        uploadFile: ({ commit }, data) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const {
                        eleccion_id,
                        onUploadProgress,
                        nombre,
                        formData,
                    } = data;

                    const _url = encodeURI(
                        `/csv-files/${eleccion_id}?nombre=${nombre}`
                    );
                    const result = await api.post(_url, formData, {
                        onUploadProgress,
                    });

                    if (!_.get(result, 'data.uploaded')) {
                        reject('Ha ocurrido un error al cargar el archivo');
                    } else {
                        resolve(result);
                    }
                } catch (error) {
                    reject(error);
                }
            });
        },
        saveFiles: ({ commit }, { election_id }) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const result = await api.post(
                        `elections/${election_id}/files`
                    );

                    resolve(result);
                } catch (error) {
                    reject(error);
                }
            });
        },
        fetchElectionTypes: ({ commit, dispatch }) => {
            return new Promise((resolve, reject) => {
                api.get('election-types')
                    .then(response => {
                        resolve(response.data.electionTypes);
                    })
                    .catch(reject);
            });
        },
        fetchElection: ({ commit, dispatch }, eleccion_id) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await api.get(`/elections/${eleccion_id}`);

                    if (response.data && response.data.eleccion) {
                        const eleccion = response.data.eleccion;

                        commit('SET_ELECCION', eleccion);
                        resolve(eleccion);
                    } else {
                        console.error('Elecciones error');
                        console.error(
                            _.get(response, 'data.reason') || "Can't get data"
                        );
                        commit('SET_ELECCION', {});
                        reject(
                            _.get(response, 'data.reason') || "Can't get data"
                        );
                    }
                } catch (error) {
                    reject(error);
                }
            });
        },
        deleteCache: ({ commit }, election_id) => {
            return new Promise((resolve, reject) => {
                api.delete(`/cache`)
                    .then(response => {
                        resolve(response.data);
                    })
                    .catch(reject);
            });
        },
    },
};
